import { render, staticRenderFns } from "./deposit-purchase.vue?vue&type=template&id=b49edb60&"
import script from "./deposit-purchase.vue?vue&type=script&lang=js&"
export * from "./deposit-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports